export type TOnboardingVariant = "admin" | "invited";

export const ONBOARDING_VARIANTS: Record<
  TOnboardingVariant,
  { excludedStepKeys: string[]; eyebrow: string }
> = {
  admin: {
    excludedStepKeys: [],
    eyebrow: "Storydoc Platform",
  },
  invited: {
    // Invited members have no starter decks.
    excludedStepKeys: ["starter-decks"],
    // Fallback eyebrow when the account's org name isn't available yet; the
    // dialog otherwise interpolates it into "Welcome to <org>'s Storydoc".
    eyebrow: "Storydoc Platform",
  },
};
